import { render, staticRenderFns } from "./chatType.vue?vue&type=template&id=e4d18688&scoped=true&"
import script from "./chatType.vue?vue&type=script&lang=js&"
export * from "./chatType.vue?vue&type=script&lang=js&"
import style0 from "./chatType.vue?vue&type=style&index=0&id=e4d18688&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d18688",
  null
  
)

export default component.exports